<template>
    <v-content>
        <v-app>
            <v-container grid-list-xl text-xs-center fluid class="container-transactions">
                <v-layout row wrap>
                    <v-flex xs2>
                        <v-text-field v-model="search.merchantCustomerId" append-icon="search" label="Customer ID" clearable @click:clear="resetFilter(search.merchantCustomerId)" v-on:keyup="searchClients"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.firstName" append-icon="search" label="First Name" clearable @click:clear="resetFilter(search.firstName)" v-on:keyup="searchClients"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.surname" append-icon="search" label="Surname" clearable @click:clear="resetFilter(search.surname)" v-on:keyup="searchClients"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.mobile" append-icon="search" label="Mobile" clearable @click:clear="resetFilter(search.mobile)" v-on:keyup="searchClients"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.email" append-icon="search" label="Email" clearable @click:clear="resetFilter(search.email)" v-on:keyup="searchClients"></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-text-field v-model="search.postcode" append-icon="search" label="Postcode" clearable @click:clear="resetFilter(search.postcode)" v-on:keyup="searchClients"></v-text-field>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex xs12>
                        <v-data-table id="transactions-table" :headers="tableHeaders" :items="clients" :rows-per-page-items="rowsPerPage" :loading="loading" class="elevation-1">
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <td class="text-xs-left">
                                    <v-btn icon>
                                        <router-link :to="`/client/${props.item.id}`"><v-icon color="blue">person</v-icon></router-link>
                                    </v-btn>   
                                </td>
                                <td class="text-xs-left">{{ props.item.merchantCustomerId }}</td>
                                <td class="text-xs-left">{{ props.item.firstName }} {{ props.item.surname }}</td>
                                <td class="text-xs-left">0{{ props.item.mobile }}</td>
                                <td class="text-xs-left">{{ props.item.email }}</td>
                                <td class="text-xs-left">{{ props.item.postcode }}</td>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
import axios from 'axios';
import sweetAlert from '../sweetAlert.js';

export default {
    data() {
        return {
            rules: { required: [ v => !!v || 'Required' ],
                     email: [ v => this.emailRule(v) ],
            },
            search: {
                merchantCustomerId: null,
                firstName: null,
                surname: null,
                mobile: null,
                email: null,
                postcode: null
            },
            rowsPerPage:[10, 25, 50, 100],
            loading: false,
            clients: [],
            tableHeaders: [{ text: '', sortable: false, align: 'left' },
                           { text: 'Customer Id', sortable: false, align: 'left' },
                           { text: 'Name', sortable: false, align: 'left' },
                           { text: 'Mobile', sortable: false, align: 'left' },
                           { text: 'Email', sortable: false, align: 'left' },
                           { text: 'Postcode', sortable: false, align: 'left' }]
        }
    },
    beforeMount() {
        this.searchClients();
    },
    methods: {
        searchClients() {

            // if(Object.getOwnPropertyNames(this.search).length > 0) {
            //     console.log('Not empty');
            // }
            // else {
            //     console.log('Empty');
            // }

            axios({
                method: 'post',
                url: 'https://controlapi.totalprocessing.com/api/client-search-clients',
                data: { search: this.search, merchantId: localStorage.merchant_access },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.clients = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
        },
        emailRule(v) {
            let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(typeof v !== 'undefined' && v)
            {   if(!pattern.test(v)) {
                    return 'Invalid Email address';
                }
                else { 
                    return true;
                }
            } 
            else {
                return true;
            }
        },
        resetFilter(field) {
            this.field = null;
            this.searchClients();
        },
    }
}
</script>

<style>
    #btn-add-client {
        margin-top: 14px;
    }

    #transactions-table a {
        text-decoration: none;
    }
</style>